import React from 'react'

import * as Analytics from 'analytics/analytics'
import BodyText from 'LuxKit/Typography/BodyText'
import Modal from 'LuxKit/Modal/Modal'

function RefreshSearchModal() {
  return (
    <Modal
      title="Your search session has expired"
      primaryActionText="Refresh"
      onPrimaryActionClick={() => {
        Analytics.trackClientEvent({
          subject: 'expired',
          action: 'refresh',
          category: 'search',
          type: 'interaction',
        })
        window.location.reload()
      }}
    >
      <BodyText variant="large">
        Refresh your search to see available offers.
      </BodyText>
    </Modal>
  )
}

export default RefreshSearchModal
